import React from 'react'
import _ from 'lodash'

import { ButtonTag } from 'components/Form'
import { channels as channelsNewApi } from 'api'
import { lang } from 'utils/helpers'

const WhatsappValidationButton = (props) => {
  const { label, description, channel, onOTPVerification, onSubmit } = props
  const { wabaId, botId, appId, systemUserAccessToken } = channel.value
  const oldValue = { wabaId, botId, appId, systemUserAccessToken }

  const [oldConfigWhatsapp, setOldConfigWhatsapp] = React.useState(oldValue)
  const [configIsEqual, setConfigIsEqual] = React.useState(false)
  const [showValidationButton, setShowValidationButton] = React.useState(true)
  const [isSubmit, setIsSubmit] = React.useState(false)
  const [isDisabled, setIsDisabled] = React.useState(false)
  const [validationLabelStatus, setValidationLabelStatus] = React.useState(label)

  React.useEffect(() => {
    const newConfigWhatsapp = { wabaId, botId, appId, systemUserAccessToken }
    const configWhatsappIsEqual = _.isEqual(oldConfigWhatsapp, newConfigWhatsapp)

    if(configWhatsappIsEqual && channel.value.validateWhatsappButton === 'VERIFIED') {
      setShowValidationButton(false)
      return
    }

    if(configWhatsappIsEqual && channel.value.validateWhatsappButton === 'NOT_VERIFIED') {
      setValidationLabelStatus(label)
      setShowValidationButton(true)
      setConfigIsEqual(false)
      return
    }

    if(!configWhatsappIsEqual && !channel._id.includes('new')) {
      setValidationLabelStatus(label)
      setShowValidationButton(true)
      setConfigIsEqual(false)
      return
    }

    setShowValidationButton(true)
    setConfigIsEqual(true)
  }, [wabaId, botId, appId, systemUserAccessToken, channel.value])

  const validateWhatsapp = async () => {
    if (isDisabled) return
    
    setIsSubmit(true)
    setIsDisabled(true)
    
    try {
      if (!wabaId || !botId || !appId || !systemUserAccessToken) throw new Error('required_fields')
      const config = { wabaId, botId, appId, systemUserAccessToken }

      if (!channel._id.includes('new')) config.credential = channel._id

      await channelsNewApi.verifyWhatsappChannel(config)

      channel.value.validateWhatsappButton = 'VERIFIED'

      setConfigIsEqual(true)
      setValidationLabelStatus(`¡${lang('dashboard_successful-verification')}!`)
      delete config.credential
      setOldConfigWhatsapp(config)
      onSubmit()
    } catch(error) {
      if (error.response && error.response.data.message === 'otp_verification_required') {
        onOTPVerification()
      } else {
        setValidationLabelStatus(`¡${lang('dashboard_incorrect-verification')}!`)
        channel.value.validateWhatsappButton = 'NOT_VERIFIED'
      }
      setConfigIsEqual(false)
    }

    setIsSubmit(false)
    setIsDisabled(false)
  }

  return (
    showValidationButton && <div className='channel-field input'>
      <div className='field-content grid grid--small'>
        <ButtonTag 
          className={!configIsEqual ? 'whatsapp_button_tag_error' : 'tag-button.button-primary'}
          value={lang(validationLabelStatus)}
          isSubmitting={isSubmit}
          onClick={validateWhatsapp}
          disabled={isDisabled}
          size={'large'}/>
        {description && <p className='description'>{lang(description)}</p>}
      </div>
    </div>
  )
}

export default WhatsappValidationButton
